import React from "react";
import { useForm } from "react-hook-form";
import { Button, Form, Modal } from "react-bootstrap";

import {
  socialLinkConstants,
  socialLinkPlatformEnum,
} from "../../../../views/admin-screens/constants";

const {
  MAX_LINK_LENGTH,
  LINK_LIMIT_ERROR,
  WEBSITE_URL_PATTERN,
  FACEBOOK_URL_PATTERN,
  INSTAGRAM_URL_PATTERN,

  WEBSITE_URL_ERROR,
  FACEBOOK_URL_ERROR,
  INSTAGRAM_URL_ERROR,
} = socialLinkConstants;

const UpdateBrandSocialLinkModal = (props) => {
  const {
    data,
    show,
    onClose,
    animate,
    onConfirm,
    ModalSize,
    CancelButtonText,
    UpdateButtonText,
    SubmitButtonStyle,
    CancelButtonStyle,
    SubmitButtonVariant,
    SubmitButtonClasses,
    CancelButtonVariant,
    CancelButtonClasses,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: data });

  const onSubmit = (formData) => {
    const links = [
      { platform: socialLinkPlatformEnum.Facebook, url: formData.facebookLink },
      {
        platform: socialLinkPlatformEnum.Instagram,
        url: formData.instagramLink,
      },
      {
        platform: socialLinkPlatformEnum.BrandWebsite,
        url: formData.brandWebsiteLink,
      },
    ];

    const dataToSend = {
      brandId: formData?.brandId,
      links: links,
    };
    onConfirm(dataToSend);
  };

  return (
    <Modal
      show={show}
      size={ModalSize}
      onHide={onClose}
      animation={animate}
      className="react-survey-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Brand</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Form.Group>
            <Form.Label className="mb-1">Brand:</Form.Label>
            <Form.Control
              disabled
              type="text"
              {...register("brandName")}
              data-testid="name-field"
              className="user-fields font-14-px text-secondary mb-3"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-1">Facebook Link:</Form.Label>
            <Form.Control
              type="url"
              placeholder="Enter Facebook profile link"
              isInvalid={errors.facebookLink}
              {...register("facebookLink", {
                maxLength: {
                  value: MAX_LINK_LENGTH,
                  message: LINK_LIMIT_ERROR,
                },
                pattern: {
                  value: FACEBOOK_URL_PATTERN,
                  message: FACEBOOK_URL_ERROR,
                },
              })}
              className="form-control user-fields font-14-px"
            />
            {errors.facebookLink && (
              <Form.Text className="text-danger">
                {errors.facebookLink.message}
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-1">Instagram Link:</Form.Label>
            <Form.Control
              type="url"
              placeholder="Enter Instagram profile link"
              isInvalid={errors.instagramLink}
              {...register("instagramLink", {
                maxLength: {
                  value: MAX_LINK_LENGTH,
                  message: LINK_LIMIT_ERROR,
                },
                pattern: {
                  value: INSTAGRAM_URL_PATTERN,
                  message: INSTAGRAM_URL_ERROR,
                },
              })}
              className="form-control user-fields font-14-px"
            />
            {errors.instagramLink && (
              <Form.Text className="text-danger">
                {errors.instagramLink.message}
              </Form.Text>
            )}
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-1">Brand Website Link:</Form.Label>
            <Form.Control
              type="url"
              placeholder="Enter brand website URL"
              isInvalid={errors.brandWebsiteLink}
              {...register("brandWebsiteLink", {
                maxLength: {
                  value: MAX_LINK_LENGTH,
                  message: LINK_LIMIT_ERROR,
                },
                pattern: {
                  value: WEBSITE_URL_PATTERN,
                  message: WEBSITE_URL_ERROR,
                },
              })}
              className="form-control user-fields font-14-px"
            />
            {errors.brandWebsiteLink && (
              <Form.Text className="text-danger">
                {errors.brandWebsiteLink.message}
              </Form.Text>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={SubmitButtonVariant}
            className={SubmitButtonClasses}
            style={SubmitButtonStyle}
            type="submit"
          >
            {UpdateButtonText}
          </Button>
          <Button
            variant={CancelButtonVariant}
            className={CancelButtonClasses}
            style={CancelButtonStyle}
            onClick={onClose}
          >
            {CancelButtonText}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UpdateBrandSocialLinkModal;
